import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Slide from '@material-ui/core/Slide';
import { convertToRaw } from 'draft-js';

import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { baseTheme } from '../../../theme';

import PostEditor from './post-editor';
import PostHeader from './post-header';
import PostHighlights from './post-highlights';
import { updateNote, updatePost } from '../../../services/posts';
import { setPostContent, setPostNote, setPostUpdates } from '../../../store/posts/actions';

interface IPostComponentProps {
  checked: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fadeIn: {
      opacity: 1,
    },
    fadeOut: {
      opacity: 0,
    },
    postRoot: {
      width: '100%',
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(3),
      transition: theme.transitions.create('all', {
        duration: theme.transitions.duration.standard,
      }),
    },
    postContent: {
      paddingTop: '275px',
    },
    publicColor: {
      color: theme.palette.primary.main,
    },
    privateColor: {
      color: theme.palette.secondary.main,
    },
    staticColor: {
      color: theme.palette.text.primary,
    },
  }),
);

export default function PostComponent(props: IPostComponentProps) {
  const { checked = false } = props;
  const classes = useStyles(baseTheme);
  const [sticky, setSticky] = useState<boolean>(false);
  const [content, setContent] = useState<string>();
  const [note, setNote] = useState<string>();
  const postDetails = useSelector((state: any) => state.posts.selected);
  const dispatch = useDispatch();

  const handlePostChanges = (state: any) => {
    const content = JSON.stringify(convertToRaw(state.getCurrentContent()));
    setContent(content);
  };

  const savePostChanges = () => {
    updatePost({ content, id: postDetails.id });
    setPostContent(dispatch, { content, id: postDetails.id });
    setPostUpdates(dispatch, { ...postDetails, content });
  };

  const handleNoteChanges = (state: any) => {
    const content = JSON.stringify(convertToRaw(state.getCurrentContent()));
    setNote(content);
  };

  const saveNoteChanges = () => {
    updateNote(postDetails.id, { note });
    setPostNote(dispatch, { note, id: postDetails.id });
  };

  const typeResolver = postDetails.public === true
    ? 'Public'
    : postDetails.group?.type === 'Closed'
      ? 'Private'
      : 'Static';

  // Scroll Event Listener to determine when the header should be sticky to the top of page.
  window.addEventListener('scroll', (event: any) => {
    window.pageYOffset > 75 ? setSticky(true) : setSticky(false);
  });

  return (
    <Slide
      direction="left"
      in={checked}
    >
      <Grid item
        container
        direction="column"
        className={classes.postRoot}>
        <PostHeader
          sticky={sticky}
        />

        <Grid item
          container
          direction="column"
          className={`${sticky ? classes.postContent : null}`}>
          <PostEditor
            typeResolver={typeResolver}
            data={postDetails.content}
            label={'Post Content'}
            pixelHeight={800}
            handleChanges={handlePostChanges}
            onBlur={savePostChanges}
            customControls={[
              // {
              //   name: 'myThing',
              //   icon: <InvertColorsIcon />,
              //   type: 'inline',
              // },
              // {
              //   name: "clear-callback",
              //   icon: <InvertColorsIcon />,
              //   type: "callback",
              //   onClick: () => {
              //     alert('I did it!')
              //   }
              // }
            ]}
          />
        </Grid>

        <PostHighlights
          postId={postDetails.id}
          highlights={postDetails.highlights}
          typeResolver={typeResolver} />

        <Grid item container direction="column">
          <Grid item>
            <h3>Additional Notes</h3>
            Add note, affirmation, reminder, or addendum.
            Whether private, closed, or public post, this
            field is NOT seen by others.
            <hr />
          </Grid>
          <PostEditor
            typeResolver={typeResolver}
            data={postDetails.note}
            label={'Note'}
            pixelHeight={300}
            handleChanges={handleNoteChanges}
            onBlur={saveNoteChanges}
            customControls={[
              // {
              //   name: 'myThing',
              //   icon: <InvertColorsIcon />,
              //   type: 'inline',
              // },
              // {
              //   name: "clear-callback",
              //   icon: <InvertColorsIcon />,
              //   type: "callback",
              //   onClick: () => {
              //     alert('I did it!')
              //   }
              // }
            ]}
          />
        </Grid>

      </Grid>
    </Slide>
  );
}
